import { ApiConfigurationManagerGraphql, type ConfigureGraphql } from "../utils";

const apiConfigurationManager = new ApiConfigurationManagerGraphql<GraphQLResponse<unknown>>();

export const configureApi: ConfigureGraphql<GraphQLResponse<unknown>> = (config) => {
  apiConfigurationManager.config = config;
};

export type GraphQLResponseError<T extends object = object> = T & {
  extensions?: {
    code?: string;
  };
};

export type GraphQLResponse<TData, TError extends GraphQLResponseError = GraphQLResponseError> =
  | { data: TData; errors?: undefined }
  | { data?: undefined; errors: GraphQLResponseError<TError>[] };

export const useFetch = <Data, Variables>(
  query: string,
  requestHeaders?: RequestInit["headers"],
): ((variables?: Variables) => Promise<Data>) => {
  return async (variables?: Variables) => {
    await apiConfigurationManager.config.onRequest?.(query);
    const response = await fetch(`${resolveUrl(apiConfigurationManager.config.baseUrl ?? "")}/graphql`, {
      body: JSON.stringify({ query, variables }),
      headers: {
        "Content-Type": "application/json",
        ...requestHeaders,
        ...apiConfigurationManager.config.headers?.(),
      },
      method: "POST",
    });

    const result = (await response.json()) as GraphQLResponse<Data>;
    await apiConfigurationManager.config.onResponse?.(result, query);
    if (result.errors) {
      throw new Error(`GraphQL response has errors. ${JSON.stringify(result.errors, null, 2)}`);
    }

    return result.data;
  };
};

/**
 * makes a valid absolute or relative URL, splicing in query/path params.
 *
 * prevents building urls with double slashes like http://BASEURL//api/v1/...
 */
export const resolveUrl = (url: string) => {
  return url.endsWith("/") ? url.slice(0, url.length - 1) : url;
};
